import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PrebootHelperModule, UiHelperService } from 'core-max-lib';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { GeneralArticleComponent } from './components/general-article/general-article.component';
import { MagazineArticleComponent } from './components/magazine-article/magazine-article.component';
import { MagazineComponent } from './components/magazine/magazine.component';
import { MoreInfoComponent } from './components/more-info/more-info.component';
import { QuestionsAndAnswersComponent } from './components/questions-and-answers/questions-and-answers.component';
import { MagazineService } from './interfaces/magazine-service.interface';
import { MagazineLibComponent } from './magazine-lib.component';
import { MagazineArticlePipe } from './pipes/magazine-article.pipe';
import { MagazineCategoryPipe } from './pipes/magazine-category.pipe';

@NgModule({
    imports: [CommonModule, PrebootHelperModule, SlickCarouselModule],
    declarations: [
        MagazineComponent,
        MagazineArticleComponent,
        GeneralArticleComponent,
        MagazineCategoryPipe,
        MagazineArticlePipe,
        QuestionsAndAnswersComponent,
        MagazineLibComponent,
        MoreInfoComponent
    ],
    providers: [ UiHelperService ],
    exports: [
        MagazineComponent,
        MagazineArticleComponent,
        GeneralArticleComponent
    ]
})
export class MagazineLibModule {
    static forRoot(magazineService): ModuleWithProviders<MagazineLibModule> {
        return {
            ngModule: MagazineLibModule,
            providers: [{ provide: MagazineService, useClass: magazineService }]
        };
    }
}
